var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.haveAttributions
    ? _c(
        "div",
        {
          staticClass: "attributeContainer",
          attrs: { id: "attributeContainer" },
        },
        [
          _c("v-card", { staticClass: "mapAttribution pa-1" }, [
            _c(
              "ul",
              { staticClass: "pa-0 caption" },
              _vm._l(_vm.myAttributions, function (item, index) {
                return _c("li", {
                  key: index,
                  ref: "attributions",
                  refInFor: true,
                  domProps: { innerHTML: _vm._s(item) },
                })
              }),
              0
            ),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }